import { SectionContent } from '../../components';
import { ActivityTab } from '../ActivityTab';
import { PendingRecipients } from '../PendingState/PendingRecipients';
import { SidebarTabs } from '../SidebarTabs';
export function SignedState() {
    return (<SectionContent>
      <SidebarTabs recipients={<PendingRecipients />} activity={<ActivityTab />}/>
    </SectionContent>);
}
